import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export default function DeleteLeadDialog({ lead, onClose, onConfirm }) {
  return (
    <AlertDialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="lead-delete-dialog" className="bg-cream border-navy/10">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl text-navy font-medium">Delete this lead?</AlertDialogTitle>
          <AlertDialogDescription className="text-charcoal/70">
            <strong className="text-navy">{lead?.name}</strong> ({lead?.email}) will be permanently removed. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="lead-delete-cancel" className="rounded-full border-navy/20 text-navy">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="lead-delete-confirm" onClick={() => onConfirm(lead.id)} className="rounded-full bg-red-700 text-white hover:bg-red-800">Delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
